<template>
  <div>
    <el-backtop></el-backtop>
    <div>
      <header-bar></header-bar>
      <div class="search_context" style="width: 100%;">
        <div class="search_box clearfix">
          <span class="left_text_search">期刊查询</span>
          <div class="search_input">
            <div class="container">
              <div class="input">
                <div class="el-input">
                  <input type="text" v-model="text" placeholder="一键搜刊：例《山西化工》" id="search-input"
                    class="el-input__inner">
                </div>
                <ul class="picker-list" style="display: none;"></ul>
              </div>
            </div>
          </div>
          <div class="search_btn clearfix" style="display: flex;">
            <div class="div1" @click="submit()">
              检索
            </div>
            <div class="div1" @click="reset()">
              重置
            </div>
          </div>
        </div>
      </div>
      <!-- <div style="width: 80%;margin:0 auto"> -->
      <!-- <el-collapse v-model="activeName" accordion> -->
      <!-- <el-collapse-item title="筛选" name="1" style="text-align: center;"> -->
      <div class="search_wrap">
        <el-row class="periodical" style="margin-top: 10px; text-align: right;">
          <selectQikan title="文章方向" :items="direction" cate="direction" @change="selectChange"></selectQikan>
          <selectQikan title="期刊级别" :items="level" cate="level" @change="selectChange"></selectQikan>
          <selectQikan title="数据收录" :items="included_database" cate="included_database" @change="selectChange">
          </selectQikan>

          <selectQikan title="出刊周期" :items="cycle" cate="cycle" @change="selectChange"></selectQikan>
          <!-- <selectQikan title="当下收录年份" :items="year" cate="year" @change="selectChange"></selectQikan> -->
          <selectQikan title="审核难度" :items="audit_standard" cate="audit_standard" @change="selectChange"></selectQikan>
          <selectQikan title="期刊页码" :items="page_range" cate="page_range" @change="selectChange"></selectQikan>
          <!--电子刊号-->
          <el-row type="flex" justify="center" align="top">
            <el-col :span="3" style="padding: 0 30px;margin:0">期刊类型:</el-col>
            <el-col :span="14" style="text-align: left;margin:0">
              <el-checkbox-group v-model="e_number_computed" @change="set_e_number">
                <el-checkbox style="width: 100px;" :label="0">纸质期刊</el-checkbox>
                <el-checkbox style="width: 100px;" :label="1">电子期刊</el-checkbox>
                <el-checkbox style="width: 100px;" :label="2">报刊</el-checkbox>
                <el-checkbox style="width: 100px;" :label="3">国际刊</el-checkbox>
                <el-checkbox style="width: 100px;" :label="4">会议刊</el-checkbox>
              </el-checkbox-group>
              <!-- <el-radio v-model="e_number" label="0">全部</el-radio> -->
              <!-- <el-radio v-model="e_number" label="1">是</el-radio>
              <el-radio v-model="e_number" label="2">否</el-radio> -->
            </el-col>
          </el-row>
          <el-row type="flex" justify="center" align="top" style="margin-bottom: 10px;">
            <el-col :span="3" style="padding: 0 30px;margin:0">邮发代号:</el-col>
            <el-col :span="14" style="text-align: left;margin:0">
              <el-checkbox-group v-model="post_code" @change="getList()">
                <el-checkbox style="width: 80px; margin-bottom: 10px;position: absolute" :label="0">是</el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-row>

          <el-row type="flex" justify="center" align="top" style="margin-bottom: 10px;">
            <el-col :span="3" style="padding: 0 30px;margin:0">社内发票:</el-col>
            <el-col :span="14" style="text-align: left;margin:0">
              <el-checkbox-group v-model="invoice" @change="getList()">
                <el-checkbox style="width: 80px; margin-bottom: 10px;position: absolute" :label="0">是</el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-row>

          <!--封面核心-->
          <el-row type="flex" justify="center" align="top" style="margin-bottom: 10px;">
            <el-col :span="3" style="padding: 0 30px;margin:0">封面核心:</el-col>
            <el-col :span="14" style="text-align: left;margin:0">
              <el-checkbox-group v-model="cover_core" @change="getList()">
                <el-checkbox style="width: 80px; margin-bottom: 10px;position: absolute" :label="1">是</el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center" align="top" style="margin-bottom: 10px;">
            <el-col :span="3" style="padding: 0 30px;margin:0">影响因子:</el-col>
            <el-col :span="14" style="text-align: left;margin:0">
              <el-checkbox-group v-model="impact_factor" @change="getList()">
                <el-checkbox style="width: 80px; margin-bottom: 10px;position: absolute" :label="0">是</el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center" align="top" style="margin-bottom: 10px;">
            <el-col :span="3" style="padding: 0 30px;margin:0">学术目录:</el-col>
            <el-col :span="14" style="text-align: left;margin:0">
              <el-checkbox-group v-model="science_periodical" @change="getList()">
                <el-checkbox style="width: 80px; margin-bottom: 10px;position: absolute" :label="0">是</el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center" align="top" style="margin-bottom: 10px;">
            <el-col :span="3" style="padding: 0 30px;margin:0">价格排序:</el-col>
            <el-col :span="14" style="text-align: left;margin:0">
              <el-checkbox-group v-model="price_sort" @change="getList()">
                <el-checkbox style="width: 80px; margin-bottom: 10px;position: absolute" :label="0">是</el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-row>

          <!--影响因子区间-->
          <!-- <selectQikan title="影响因子区间" :items="factor_range" cate="factor_range"  @change="selectChange"></selectQikan> -->

          <!-- <el-row type="flex" justify="center" align="top" style="margin-bottom: 10px;">
                    <el-col :span="3" style="padding: 0 20px;margin:0">暂停收稿刊物：</el-col>
                    <el-col :span="14" style="text-align: left;margin:0">
                    <el-checkbox v-model="suspend_receiving" :label="0" @change="getList()">显示</el-checkbox>
                    </el-col>
                </el-row>
                <el-row type="flex" justify="center" align="top" style="margin-bottom: 10px;">
                    <el-col :span="3" style="padding: 0 30px;margin:0">第一，二批:</el-col>
                    <el-col :span="14" style="text-align: left;margin:0">
                    <el-checkbox-group v-model="science" @change="getList()">
                        <el-checkbox style="width: 80px; margin-bottom: 10px;position: absolute" :label="0">必需</el-checkbox>
                    </el-checkbox-group>
                    <el-col style="margin-left: 10%;">
                        <a
                        href="http://b.1.7cong.cn/#/"
                        class="download"
                        >文件下载：总局第一，二批认定学术期刊目录</a>
                    </el-col>
                    </el-col>
                </el-row>

                <el-row type="flex" justify="center" align="top" style="margin-bottom: 10px;">
                    <el-col :span="3" style="padding: 0 30px;margin:0">是否可查稿:</el-col>
                    <el-col :span="14" style="text-align: left;margin:0">
                    <el-checkbox-group v-model="check" @change="getList()">
                        <el-checkbox style="width: 80px; margin-bottom: 10px;position: absolute" :label="0">是</el-checkbox>
                    </el-checkbox-group>
                    </el-col>
                </el-row>

                <el-row type="flex" justify="center" align="middle" style="margin-bottom: 10px;">
                    <el-col :span="3" style="padding: 0 20px;margin:0">出刊限制时间：</el-col>
                    <el-col :span="checkedPublished ? 3 : 15" style="text-align: left;margin:0">
                    <el-date-picker
                        v-model="checkedPublished"
                        type="month"
                        value-format="yyyy-M"
                        placeholder="选择日期"
                        @change="clearHandle()"
                    ></el-date-picker>
                    </el-col>
                    <el-col v-if="checkedPublished" :span="12" style="text-align: left;margin:0;padding-left:40px">
                        <el-radio-group v-model="published" :max="date_type.length" @change="getList()">
                            <el-radio
                            style="width: 80px; margin-bottom: 10px;"
                            v-for="item in date_type"
                            :label="item.id"
                            :key="item.id"
                            >{{item.name}}
                            </el-radio>
                        </el-radio-group>
                        </el-col>
                </el-row> -->
        </el-row>
      </div>
      <!-- </el-collapse-item> -->
      <!-- </el-collapse> -->
      <!-- </div> -->
      <div v-if="hasLogin" class="container_wrap">
        <div class="box">
          <div class="tab clearfix">
            <a href="javascript:void(0)" @click="PageChange(1)" :class="{ 'activborder': PageIndex==1 }">期刊列表</a>
            &nbsp;&nbsp;&nbsp;
            <!-- <a href="javascript:void(0)" @click="PageChange(2)" :class="{ 'activborder': PageIndex==2 }">当前期刊</a> -->
          </div>
        </div>
        <!-- 当前期刊 -->
        <div class="book_box" v-if="PageIndex ==2">
          <el-row type="flex" justify="center" style="flex-direction: column;">
            <el-col :span="18" v-for="(item, index) in currentContent" :key="index"
              style="line-height: 42px; text-align: left; border-bottom: 1px dashed #e8e8e8;">
              <i class="el-icon-arrow-right"></i>
              {{item.data}}
            </el-col>
            <el-pagination background layout="prev, pager, next" :total="currenttotal" style="text-align: center"
              @current-change="currentchange">
            </el-pagination>
          </el-row>
        </div>
        <!-- 图书列表 -->
        <div class="book_box infinite-list-wrapper" v-if="PageIndex ==1">
          <el-row :gutter="20" class="clearfix">
            <el-col :span="12" v-for="(item,index) in list" class="box-infos" :key="index">
              <div class="clearfix" :id="item.id">
                <div class="img_box">
                  <el-image :src="item.cover" lazy @click="previewImg(item.cover)"></el-image>
                </div>
                <div class="detail_wrap  ">
                  <div class="detail_box">
                    <div class="bookname clearfix books-title " v-bind:id="item.id">
                      <span class="c1 top_div" v-bind:id="item.id">
                        {{item.name}}
                        <span style="font-size: 14px;color: #999999;">【{{ item.e_number === 0 ? '纸质期刊' : item.e_number === 1 ? '电子期刊' : item.e_number === 2 ? '报刊' : item.e_number === 3 ? '国际刊' : item.e_number === 4 ? '会议刊' : '' }}】</span>
                      </span>

                      <div v-bind:id="item.id"
                        style="display: inline-block; margin: 0px auto; text-align: right;position: absolute;width: 50%;right: 20%;">
                        <!-- <span class="c1 " v-bind:id="item.id" v-show="item['audit_standard']" style="color: #4CADD3;text-align: center;display: inline-block">{{item['audit_standard']}}</span> -->
                      </div>

                      <span class="c2 top_div" v-bind:id="item.id" @click="showPublishDetail(item.id)">查看详情</span>
                    </div>
                    <div class="">
                      <div class="leibie" v-bind:id="item.id">
                        <div class="d1">
                          <div v-for="(catP,index) in item['direction']" :key="index" style="display:inline-block;">
                            <span>{{catP}}</span>
                          </div>
                        </div>
                        <div class="d2"><span>{{item['level']}}/ {{item['cycle']}}</span></div>
                      </div>
                      <div class="public_date colorcom" v-bind:id="item.id">出刊时间:<span>{{item['date']}}
                          {{item['date_type']}}</span></div>
                      <div class="network colorcom" v-bind:id="item.id">
                        上网情况:
                        <div v-for="(networkP,index) in item['included_database']"
                          style="display:inline-block;margin-right: 4px" :key="index">
                          <span>{{networkP}}</span>
                        </div>
                      </div>
                      <div class="current_date colorcom">
                        当前刊期:<span>{{item['current'].content}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="down">

                        <div class="down_wrap" >
                            <a class="link-ico" v-if="hasLogin" @click="downCover(item.id)">封面下载</a>
                            <a class="link-ico" v-if="hasLogin" @click="downDoc(item.id)">征稿函下载</a>
                            <a class="basic_msg" :id="item.id" @click="showPublishInfo(item.id)">基本信息</a>
                        </div>
                    </div> -->
            </el-col>
            <el-col :span="12" v-if="dataEmpty" style="width: 100%;text-align: center;border: none;color: #4CADD3;">
              小主~没有数据了 请别再刷新数据了
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 登录注册框 -->
      <login :isLogin="isLogin" @loginVisible="loginVisible()" @loginSuccess="loginSuccess"></login>
      <!-- 登录后的查看详情框 -->
      <detail :isDetail="isDetail" :detail="detail" @detailVisible="detailVisible()"></detail>
      <!-- 封面预览 -->
      <el-dialog title="预览封面" :visible.sync="isPreviewImg" width="50%" :before-close="handleCloseImg" center>
        <el-image :src="previewImgSrc" width="100%"></el-image>
      </el-dialog>
      <!-- 图书基本信息 -->
      <el-dialog title="基本信息" :visible.sync="publishInfo" width="50%" :before-close="handleCloseInfo">
        <!-- <el-divider></el-divider> -->
        <div class="container">
          <div class="c_first">
            <div class="c_left">
              <div>
                期刊名:<span class="span">{{baseInfo.name}}</span>
              </div>
              <div>
                上网情况:<span class="span" v-for="(include,index) in baseInfo.included_database"
                  :key="index">{{include}}</span>
              </div>
              <div style="line-height: normal; height: auto;">
                版面字符:<span class="span">{{baseInfo.char_number}}</span>
              </div>
            </div>
            <div class="c_right">
              <div class="div1">
                级别:<span class="span">{{baseInfo.level}}</span>
              </div>
              <div class="div2" v-if="baseInfo.price">
                价格:
                <div class="select_wrap">
                  <select name="" v-model="selectPrice">
                    <option v-for="(price,index) in baseInfo.price" :key="index" :value="price.price"
                      :selected="0==index">{{price.role}}</option>
                  </select>
                </div>
              </div>
              <div class="price" v-if="baseInfo.price">
                <span>{{selectPrice}}元/1版</span>

              </div>
              <div class="div1" style="line-height: normal; height: auto;">
                刊期:<span class="span">{{baseInfo.current.content}}</span>
              </div>
            </div>
          </div>
          <div class="c_secend">
            <p class="copy2" @click="copy1"> 一键复制</p>
          </div>
          <div class="c_bottom">
            <div class="div1">
              附件信息:<span class="span">{{baseInfo.remark}}</span>
            </div>
            <p class="copy2 copy1" @click="copy2">复制备注</p>
          </div>
        </div>

      </el-dialog>
      <!-- 底部 -->
      <footerBar></footerBar>

    </div>

  </div>

</template>
<script>
import headerBar from './header/Header'
import footerBar from './footer/Footer'
import selectQikan from './select/Select'
import login from './login/Login'
import $H from '@/common/request.js'
import Detail from './detail/Detail'
export default {
  components: {
    headerBar,
    footerBar,
    selectQikan,
    login,
    Detail
  },
  data () {
    return {
      e_number_computed: [],
      activeName: '1',
      hasLogin: false,
      text: '',
      page: 1,
      limit: 6,
      PageIndex: 1,
      requestData: null, // 请求参数
      list: [], // 期刊列表
      checkedPublished: null,
      published: null,
      direction: [],
      included_database: [],
      level: [],
      cycle: [],
      year: [{
        id: 1,
        name: 2017
      },
      {
        id: 2,
        name: 2018
      },
      {
        id: 3,
        name: 2019
      },
      {
        id: 4,
        name: 2020
      },
      {
        id: 5,
        name: 2021
      },
      {
        id: 6,
        name: 2022
      },
      {
        id: 7,
        name: 2023
      }
      ],
      page_range: [{
        id: 1,
        name: '100以内',
        value: 100
      },
      {
        id: 2,
        name: '200以内',
        value: 200
      },
      {
        id: 3,
        name: '300以内',
        value: 300
      },
      {
        id: 4,
        name: '400以内',
        value: 400
      },
      {
        id: 5,
        name: '500以内',
        value: 500
      }
      ],
      audit_standard: [{
        id: 1,
        name: '难'
      },
      {
        id: 2,
        name: '中'
      },
      {
        id: 3,
        name: '易'
      }
      ],
      invoice: 0,
      suspend_receiving: 0,
      science: 0,
      post_code: 0,
      e_number: [],
      check: 0,
      cover_core: 0,
      impact_factor: 0,
      price_sort: 0,
      science_periodical: 0,
      factor_range: [{
        id: 1,
        name: '0-0.1',
        value: 0.1
      },
      {
        id: 2,
        name: '0.1-0.2',
        value: 0.2
      },
      {
        id: 3,
        name: '0.2以上',
        value: 0.3
      }
      ],
      date_y: 0,
      date_m: 0,
      date_type: [{
        id: 1,
        name: '月初'
      },
      {
        id: 2,
        name: '上旬'
      },
      {
        id: 3,
        name: '中旬'
      },
      {
        id: 4,
        name: '下旬'
      },
      {
        id: 5,
        name: '月底'
      }
      ],
      publishMaxPage: 0,
      dataEmpty: false,
      previewImgSrc: '',
      isPreviewImg: false,
      currenttotal: 0,
      currentContent: [],
      publishInfo: false,
      baseInfo: {
        id: 1,
        name: '少年科普报',
        included_database_id: 1,
        included_database: '龙源',
        char_number: '2500字符/1版',
        remark: '', // 附件信息
        level_id: 1,
        level: '省级',
        price: [ // 价格 未登录时不返回
          {
            id: 1,
            role_id: 1,
            role: '大代理',
            price: '950元/3版（超过6000字符按千字符收费）'
          }

        ],
        current: '0315少年科普报xxxxx'
      },
      isLogin: false,
      user: {},
      price: '',
      selectPrice: {},
      detail: {
        id: 1,
        name: '少年科普报',
        cover: 'http://xxxx.png',
        audit_standard_id: 1,
        audit_standard: 'C级',
        direction: [
          '综合类',
          '教育类'
        ],
        level_id: 1,
        level: '省级',
        cycle_id: 1,
        cycle: '周刊',
        date: '2021-03',
        date_type_id: 1,
        date_type: '月初',
        included_database: ['龙源', '知网'],
        current: '0315少年科普报xxxxx',
        letter: 'http://xxxx.pdf',
        science_periodical: '第一批',
        history: [{
          id: 2,
          date: '', // timestamp
          data: '03.08 通信电源技术 收2020年12下（24期） 预计2021年4月中上旬左右出刊；2021年1下（2期） 预计2021年4月中上旬左右出刊'
        }],
        price: [{
          id: 1,
          role_id: 1,
          role: '大代理',
          price: '950元/3版（超过6000字符按千字符收费）'
        }],
        domestic_number: '42-1380/TN',
        international_number: '1009-3664',
        post_code: '38-371',
        char_count: '2500字符/1版',
        organizer: '抚顺日报',
        management: '抚顺日报',
        cover_core: 0,
        impact_factor: 0,
        price_sort: 0,
        simple: '一篇文章1本样刊,多一本20元',
        page: '398',
        page_remark: '固定页码',
        postcode: '可要可不要',
        summary_keywords: '可要可不要',
        author_info: '可要可不要',
        references: '可要可不要',
        review_difficulty: '一般',
        review_time: '1天',
        column: '主要栏目:科学探索、教研视点、信息技术、幼儿教育、小学教育、中学教育、高等教育等',
        remark: '',
        favorite: '0'

      },
      isDetail: false,
      cuLimit: 10,
      cuPage: 1
    }
  },
  watch: {
    selectPrice (v) {
      console.log(v)
    }
  },
  created () {
    window.addEventListener('scroll', this.Scrollbottom)
  },
  estroyed () {
    window.removeEventListener('scroll', this.Scrollbottom) // 页面离开后销毁监听事件
  },
  mounted () {
    // 获取期刊方向
    $H.get('/periodical/getDirectionOptions').then(res => {
      this.direction = res
    })

    // 数据收录
    $H.get('/periodical/getIncludedDatabaseOptions').then(res => {
      this.included_database = res
    })

    // 获取期刊级别选项
    $H.get('/periodical/getLevelOptions').then(res => {
      this.level = res
    })

    // 获取期刊周期选项
    $H.get('/periodical/getCycleOptions').then(res => {
      this.cycle = res
    })

    this.getList()

    let user = localStorage.getItem('loginUser')
    let loginTime = localStorage.getItem('loginTime')
    if (user) {
      user = JSON.parse(user)
      if (loginTime) {
        let time = Math.round(new Date().getTime() / 1000)
        if (time - Number(loginTime) > 86400) {
          this.hasLogin = false
        } else {
          if (user.access_token) {
            this.hasLogin = true
            this.user = user
          }
        }
      }
    }
  },
  methods: {
    submit () {
      this.page = 1
      this.list = []
      this.getList()
    },
    reset () {
      // this.text = "";
      // this.checkedPublished = [];
      // this.requestData = null;
      // this.published = 0;
      // this.date_y = 0;
      // this.date_m = 0;
      location.reload()
    },
    selectChange (v, cate) {
      switch (cate) {
        case 'direction':
          this.requestData = {
            ...this.requestData,
            direction: v
          }
          break
        case 'included_database':
          this.requestData = {
            ...this.requestData,
            included_database: v
          }
          break
        case 'level':
          this.requestData = {
            ...this.requestData,
            level: v
          }
          break
        case 'cycle':
          this.requestData = {
            ...this.requestData,
            cycle: v
          }
          break
        case 'audit_standard':
          this.requestData = {
            ...this.requestData,
            audit_standard: v
          }
          break
      }
      if (cate == 'factor_range') {
        let factor_range = []
        v.forEach(item => {
          this.factor_range.forEach(y => {
            if (item == y.id) {
              factor_range.push(y.value)
            }
          })
        })
        this.requestData = {
          ...this.requestData,
          factor_range: factor_range
        }
      }
      if (cate == 'year') {
        let year = []
        v.forEach(item => {
          this.year.forEach(y => {
            if (item == y.id) {
              year.push(y.name)
            }
          })
        })
        this.requestData = {
          ...this.requestData,
          year: year
        }
      }
      if (cate == 'page_range') {
        let page = []
        v.forEach(item => {
          this.page_range.forEach(y => {
            if (item == y.id) {
              page.push(y.value)
            }
          })
        })
        this.requestData = {
          ...this.requestData,
          page_range: page
        }
      }
      this.getList()
    },
    // 获取期刊
    getList () {
      let user = localStorage.getItem('loginUser')
      let loginTime = localStorage.getItem('loginTime')
      if (user) {
        console.log(user)
        user = JSON.parse(user)
        if (loginTime) {
          let time = Math.round(new Date().getTime() / 1000)
          if (time - Number(loginTime) > 86400) {
            this.hasLogin = false
          } else {
            if (user.access_token) {
              this.hasLogin = true
              this.user = user
            }
          }
        }
      }
      if (!this.hasLogin) {
        this.$message.error('请先登录！')
        this.isLogin = true
        return
      }
      if (this.invoice) {
        this.requestData = {
          ...this.requestData,
          invoice: 1
        }
      } else {
        this.JsonDelItem(this.requestData, 'invoice')
      }
      if (this.suspend_receiving) {
        this.requestData = {
          ...this.requestData,
          suspend_receiving: 1
        }
      } else {
        this.JsonDelItem(this.requestData, 'suspend_receiving')
      }
      if (this.science) {
        this.requestData = {
          ...this.requestData,
          science: 1
        }
      } else {
        this.JsonDelItem(this.requestData, 'science')
      }
      if (this.post_code) {
        this.requestData = {
          ...this.requestData,
          post_code: 1
        }
      } else {
        this.JsonDelItem(this.requestData, 'post_code')
      }
      if (this.e_number.length>0) {
      this.requestData = {
        ...this.requestData,
        e_number: this.e_number
      }
      } else {
        this.JsonDelItem(this.requestData, 'e_number')
      }
      if (this.check) {
        this.requestData = {
          ...this.requestData,
          check: 1
        }
      } else {
        this.JsonDelItem(this.requestData, 'check')
      }
      if (this.cover_core) {
        this.requestData = {
          ...this.requestData,
          cover_core: 1
        }
      } else {
        this.JsonDelItem(this.requestData, 'cover_core')
      }
      if (this.science_periodical) {
        this.requestData = {
          ...this.requestData,
          science_periodical: 1
        }
      } else {
        this.JsonDelItem(this.requestData, 'science_periodical')
      }
      if (this.impact_factor) {
        this.requestData = {
          ...this.requestData,
          impact_factor: 1
        }
      } else {
        this.JsonDelItem(this.requestData, 'impact_factor')
      }
      if (this.price_sort) {
        this.requestData = {
          ...this.requestData,
          sort: 'price'
        }
      } else {
        this.JsonDelItem(this.requestData, 'sort')
      }
      if (this.date_y > 0) {
        this.requestData = {
          ...this.requestData,
          date_y: this.date_y
        }
      } else {
        this.JsonDelItem(this.requestData, 'date_y')
      }
      if (this.date_m > 0) {
        this.requestData = {
          ...this.requestData,
          date_m: this.date_m
        }
      } else {
        this.JsonDelItem(this.requestData, 'date_m')
      }
      if (this.published > 0) {
        this.requestData = {
          ...this.requestData,
          date_type: this.published
        }
      } else {
        this.JsonDelItem(this.requestData, 'date_type')
      }

      if (this.text) {
        this.requestData = {
          ...this.requestData,
          keyword: this.text
        }
      } else {
        this.JsonDelItem(this.requestData, 'keyword')
      }
      this.requestData = {
        ...this.requestData,
        page: this.page,
        limit: this.limit
      }
      this.dataEmpty = false
      let that = this
      $H.get('/periodical/list', this.requestData).then(res => {
        this.publishMaxPage = Math.ceil(res.count / this.limit)
        if (res.count == 0) {
          this.dataEmpty = true
        }
        // this.list = res.data;
        res.data.forEach(function (c) {
          that.list.push(c)
        })
      })
    },
    clearHandle () {
      let date = this.checkedPublished.split('-')
      this.date_y = date[0]
      this.date_m = date[1]
      this.getList()
    },
    PageChange (index) {
      this.PageIndex = index
      if (index == 2) {
        if (this.currentContent.length == 0) {
          this.Currentperiodical()
        }
      }
      if (index == 1) {
        this.page = 1
        this.dataEmpty = false
        this.getList()
      }
    },
    Currentperiodical () {
      $H.get('/periodical/current', {
        page: this.cuPage,
        limit: this.cuLimit
      }).then(res => {
        this.currenttotal = res.total
        if (res.data) {
          res.data.forEach(item => {
            this.currentContent.push(item)
          })
        }
      })
    },
    currentchange () {
      // 数据获取 当前期刊
      this.cuPage++
      this.Currentperiodical()
    },
    Scrollbottom () {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let clientHeight = document.documentElement.clientHeight
      let scrollHeight = document.documentElement.scrollHeight - 1
      if (scrollTop + clientHeight >= scrollHeight) {
        if (this.page + 1 <= this.publishMaxPage) {
          this.page = this.page + 1
          this.getList()
        } else {
          this.dataEmpty = true
        }
      }
    },

    previewImg: function (src) {
      this.previewImgSrc = src
      this.isPreviewImg = true
    },
    handleCloseImg: function () {
      this.isPreviewImg = false
    },
    goTop () {
      $('#wrapper').animate({
        scrollTop: 0
      }, 'slow')
    },
    JsonDelItem (JSONArray, index) {
      for (var key in JSONArray) {
        if (key == index || JSONArray[key] == index) {
          delete JSONArray[key]
          break
        }
      }
    },
    showPublishInfo (id) {
      let header = {}
      if (this.hasLogin) {
        header = {
          'Authorization': 'Bearer ' + this.user.access_token
        }
        $H.get('/periodical/baseInfo', {
          id: id
        }, header).then(res => {
          this.baseInfo = res
          this.publishInfo = true
        })
      } else {
        this.isLogin = true
      }
    },
    showPublishDetail (id) {
      if (!this.hasLogin) {
        this.isLogin = true
      } else {
        if (this.hasLogin) {
          let header = {
            'Authorization': 'Bearer ' + this.user.access_token
          }

          $H.get('/periodical/detail', {
            id: id
          }, header).then(res => {
            console.log(res)
            this.detail = res
            this.isDetail = true
          })
        }
      }
    },
    handleCloseInfo () {
      this.publishInfo = false
    },
    loginVisible () {
      this.isLogin = false
    },
    loginSuccess () {
      this.isLogin = false
      this.hasLogin = true
      let user = localStorage.getItem('loginUser')
      let loginTime = localStorage.getItem('loginTime')
      if (user) {
        console.log(user)
        user = JSON.parse(user)
        if (loginTime) {
          let time = Math.round(new Date().getTime() / 1000)
          if (time - Number(loginTime) > 86400) {
            this.hasLogin = false
          } else {
            if (user.access_token) {
              this.hasLogin = true
              this.user = user
            }
          }
        }
      }
      location.reload()
    },
    copy1 () {
      var textarea = document.createElement('textarea')
      document.body.appendChild(textarea)
      var network = ''
      for (var i = 0; i < this.baseInfo.included_database.length; i++) {
        network += this.baseInfo.included_database[i]
      }
      var HTml = ''
      if (this.hasLogin) {
        HTml = '期刊名:' + this.baseInfo.name + ',' +
            '级别:' + this.baseInfo.level + ';' + '\n' +
            '上网情况:' + network + ';' + '\n' +
            '版面字符' + this.baseInfo.char_number + ';' + '\n' +
            '价格:' + this.selectPrice + ';' + '\n' +
            '刊期:' + this.baseInfo.current + '。'
      } else {
        HTml = '期刊名:' + this.baseInfo.name + ',' +
            '级别:' + this.baseInfo.level + ';' + '\n' +
            '上网情况:' + network + ';' + '\n' +
            '版面字符' + this.baseInfo.char_number + ';' + '\n' +
            '刊期:' + this.baseInfo.current + '。'
      }
      textarea.value = HTml
      textarea.select()
      document.execCommand('Copy')
      document.body.removeChild(textarea)
      this.$message({
        message: '复制成功',
        type: 'success',
        duration: 1000
      })
    },
    copy2 () {
      var textarea = document.createElement('textarea')
      document.body.appendChild(textarea)
      var HTml = ''

      HTml = '附件信息:' + this.baseInfo.remark + '.'
      textarea.value = HTml
      textarea.select()
      document.execCommand('Copy')
      document.body.removeChild(textarea)
      this.$message({
        message: '复制成功',
        type: 'success',
        duration: 1000
      })
    },
    detailVisible () {
      this.isDetail = false
    },
    downCover (id) {
      let header = {
        'Authorization': 'Bearer ' + this.user.access_token
      }

      $H.get('/periodical/detail', {
        id: id
      }, header).then(res => {
        window.open(res.cover)
      })
    },
    downDoc (id) {
      let header = {
        'Authorization': 'Bearer ' + this.user.access_token
      }

      $H.get('/periodical/detail', {
        id: id
      }, header).then(res => {
        window.open(res.letter)
      })
    },
    set_e_number () {
      console.log(this.e_number_computed)
      this.e_number = this.e_number_computed
      // if (this.e_number_computed.length == 0) {
      //   this.e_number = 0
      // } else if (this.e_number_computed.length > 1) {
      //   this.e_number_computed = [this.e_number_computed[1]]
      //   this.e_number = this.e_number_computed[0]
      // } else {
      //   this.e_number = this.e_number_computed[0]
      // }
    }
  }
}
</script>
<style scoped>
  .search_context {
    margin-top: 70px;
    width: 100%;
    background: #4CADD3;
    padding: 40px 0px;
    box-sizing: border-box;
  }

  .search_box {
    width: 80%;
    margin: 0px auto;
    box-sizing: border-box;
  }

  .left_text_search {
    color: white;
    display: block;
    float: left;
    width: 15%;
    font-size: 26px;
    height: 48px;
    line-height: 48px;
    overflow: hidden;
  }

  @media screen and (max-width: 1200px) {
    .search_input {
      width: 65%;
    }

    .search_btn {
      width: 20%;
    }
  }

  @media screen and (max-width: 1514px) {
    .search_input {
      width: 67%;
    }

    .search_btn {
      width: 18%;
    }
  }

  .container {
    width: 100%;
    position: relative;
  }

  .search_input {
    width: 60%;
    float: left;
  }

  .container .input {
    position: relative;
    width: 100%;
    height: 48px;
    border-radius: 4px 0 0 4px;
  }

  .container>div {
    float: left;
  }

  .container:after {
    content: '';
    display: block;
    clear: both;
  }

  .search_btn {
    width: 15%;
    float: left;
  }

  .clearfix {
    *zoom: 1;
  }

  .container .input .el-input__inner {
    height: 48px;
  }

  .el-input__inner {
    -webkit-appearance: none;
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
    transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
    width: 100%;
  }

  .search_btn .div1 {
    width: 80px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    font-size: 14px;
    color: #4CADD3;
    opacity: 1;
    background: rgba(216, 239, 230, 1);
    border-radius: 3px;
    position: relative;
    display: inline-block;
    cursor: pointer;
    margin: 0px 5px;
    border: 0px;
    float: right;
  }

  .el-checkbox {
    color: #606266;
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
    user-select: none;
    margin-right: 30px;
  }

  .el-image {
    width: 100%;
  }

  .layui-layer-content {
    overflow: auto !important;
  }

  .layer-class-boder {
    background-color: inherit !important;
  }

  .layer-class-boder1 {
    background-color: #FFFFFF;
    border-radius: 50px;
  }

  .tab {
    margin-top: 30px;
    display: inline-block;
    border-bottom: 1px solid #4CADD3;
    padding-bottom: 6px;
  }

  .tab a {
    width: 50%;
    font-family: SourceHanSansSC;
    font-size: 16px;
    color: #5E5E5E;
    text-align: right;
    cursor: pointer;
    position: relative;
    z-index: 9;
  }

  .activStyle {
    color: #4CADD3 !important;
  }

  .activborder::after {
    content: "";
    width: 100%;
    height: 6px;
    border: 1px solid #4CADD3;
    position: absolute;
    top: 24px;
    left: 0px;
    background: #4CADD3;
  }

  [v-cloak] {
    display: none
  }

  .fixisActive {
    position: absolute;
    z-index: 999999999;
    width: 100%;
    top: 193px
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter,
  .fade-leave-to

  /* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
  }

  .actionPadding {
    padding: 16px;
  }

  .el-col-18 {
    width: 100% !important;
  }

  .el-pagination {
    margin: 30px auto;
  }

  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #4CADD3 !important;
  }

  .el-pagination.is-background .el-pager li:hover {
    color: #4CADD3 !important;
  }

  .head_title i {
    font-style: normal;
    cursor: pointer;
  }

  .download {
    color: #4CADD3;
    text-decoration: none;
    font-size: 14px;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #409eff;
    border-color: #409eff;
  }

  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #4CADD3;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #4CADD3;
    border-color: #4CADD3;
  }

  .top_div:hover {
    cursor: pointer;
  }

  .none-date {
    width: 100%;
    text-align: center;
    border: none;
    color: #4CADD3;
  }

  .container_wrap .el-image {
    display: block;
    min-height: 200px;
    margin-bottom: 10px;
  }

  .login-mass {
    position: absolute;
    top: 116%;
    right: 5%;
    background-color: #fff;
    line-height: 16px;
    text-align: left;
    font-size: 14px;
    padding: 1%;
    border-radius: 9px;
    z-index: 2;
    color: #4CADD3;
    cursor: pointer;
  }

  .login-tragi {
    position: absolute;
    top: -27%;
    right: 17%;
    z-index: 2;
    cursor: pointer;
    color: #fff;
    font-size: 24px;
  }

  .head_right {
    position: relative;
  }

  .el-message-box__title {
    position: relative;
    margin-top: 6%;
    margin-bottom: 16%;
  }

  .el-message-box__title span {
    color: #303133;
    font-size: 24px;
    font-family: PingFang-SC-Bold;
    color: #4CADD3;
    opacity: 1;
    position: absolute;
    top: 64%;
    right: 39%;
  }

  .el-message-box__btns {
    text-align: center;
    padding: 5px 31% 0;
  }

  .msgboxinput {
    display: block;
    height: 41px;
    width: 82%;
    margin: 6% auto;
    border: 1px solid #E2E2E2;
    opacity: 1;
    border-radius: 5px;
    padding-left: 10px;
  }

  .el-button--mini,
  .el-button--small {
    font-size: 14px;
    border-radius: 3px;
    /* padding-right: 47%; */
    position: relative;
    top: 0;
    left: 0;
    width: 67%;
    border-radius: 50px;
    margin-bottom: 13%;

  }

  .el-message-box--center .el-message-box__header {
    padding-top: 4px;
  }

  .el-button--mini,
  .el-button--small:hover {
    color: white !important;
    border-color: #4CADD3 !important;
    background-color: #4CADD3 !important;
  }

  .el-button--mini,
  .el-button--small:focus {
    color: white !important;
    border-color: #4CADD3 !important;
    background-color: #4CADD3 !important;
  }

  .msgboxspan {
    position: relative;
    font-size: 12px;
    top: -1px;
    left: 10%;
    opacity: 0.7;
    display: inline-block;
    margin-bottom: 4%;
  }

  #login_telcolor {
    background-color: #fff;
    border: none;
  }

  #login_telcolor:hover {
    background-color: #fff !important;

  }

  #login_telcolor:active {
    background-color: #fff !important;
  }

  #login_telcolor:hover {
    background-color: #fff !important;
  }

  #login_telcolor:focus {
    background-color: #fff !important;
  }

  .xiugaimima:hover {
    background-color: rgba(216, 239, 230, 1) !important;
    color: #4CADD3 !important;

  }

  i.el-message-box__close.el-icon-close:hover {
    color: #4CADD3;
  }

  .login-username-hover:hover {
    cursor: pointer;
  }

  #xiugaimass {
    background-color: #FFFFFF;
  }

  .info {
    width: 239px;
    height: 64px;
    background: linear-gradient(98deg, #EFC8A1 0%, #EABD88 22%, #E0A652 74%, #DC9E3D 100%);
    opacity: 1;
    border-radius: 6px;

  }

  .infowrap {
    padding: 20px 0px;
  }

  .info p {
    color: #FFFFFF;
    opacity: 1;

    line-height: 17px;
    font-size: 14px;
    padding: 5px 5px 5px 20px;

  }

  .infowrap .el-card__body {
    padding: 0px !important;
  }

  .infowrap .text {
    margin: 15px auto;
    cursor: pointer;
  }

  .infowrap a {
    color: #606266;
  }

  .el-popover {
    padding: 0px !important;
  }

  .infowrap {
    width: 240px;
    margin: 0 auto;
  }

  .huiyuanno {
    color: gray;
    padding-left: 6px;

  }

  .huiyuan {
    color: #F4AE52;

  }

  .statistic {
    font-size: 14px;
    position: relative;
    cursor: pointer;
  }

  .statistic1 {
    padding: 0 5px 0 5px;
    color: #DADADA !important;
  }

  .statistic_img {
    position: absolute;
    top: 24px;
    left: -42px;
    z-index: 3;
  }

  .detailOfnum {
    font-size: 14px;
    color: #4CADD3;
    margin-right: 30px;
  }

  .imgOfdel {
    width: 12px;
    height: 12px;
  }

  .el-radio__input.is-checked+.el-radio__label {
    color: #4CADD3;
  }

  .el-radio__input.is-checked .el-radio__inner {
    border-color: #4CADD3;
    background: #4CADD3;
  }

  .el-radio__inner:hover {
    border-color: #4CADD3;
  }

  .el-input__inner:focus {
    border-color: #4CADD3;
    outline: 0;
  }

  .el-month-table td.current:not(.disabled) .cell {
    color: #4CADD3;
  }

  .el-month-table td .cell:hover {
    color: #4CADD3;
  }

  .el-month-table td.today .cell {
    color: #4CADD3;
  }

  .bandreal-class-boder .layui-layer-title {
    background: #4CADD3 !important;
    color: white !important;
  }

  .number {
    font-size: 14px;
    position: absolute;
    right: 28%;
    bottom: 0;
    color: #4CADD3;
  }

  .batch {
    right: 43%;
  }

  .box {
    width: 80%;
    margin: 0 auto;
  }

  .book_box {
    width: 80%;
    margin: 0 auto;
    padding-bottom: 50px;
    margin-top: 2%;
  }

  .clearfix:after {
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }

  .box-infos:nth-child(odd) {
    margin-right: 4%;
  }

  .box-infos {
    position: relative;
    padding-bottom: 2.5%;
    margin-bottom: 3%;
    width: 48% !important;
  }

  @media screen and (max-width: 1200px) {
    .box-infos {
      height: 300px;
    }
  }

  .img_box {
    height: 240px;
    float: left;
    width: 20%;
    position: relative;
  }

  .detail_wrap {
    position: relative;
    width: -moz-calc(100% - 169px);
    width: -webkit-calc(100% - 169px);
    width: calc(100% - 169px);
    float: right;
  }

  .detail_box {
    margin: 0 auto;
    width: 100%;
  }

  .books-title {
    position: relative;
    margin-bottom: 3%;
  }

  .detail_box .bookname .c1 {
    color: #383838;
    font-size: 18px;
    opacity: 1;
    font-weight: bold;
  }

  .detail_box .bookname span {
    display: inline-block;
  }

  .detail_box .bookname .c2 {
    color: #383838;
    font-size: 14px;
    cursor: pointer;
    color: #5E5E5E;
    background-image: url(../common/style/img/JT.png);
    background-repeat: no-repeat;
    background-position: center right;
    padding-right: 10px;
  }

  .detail_box .bookname span {
    display: inline-block;
  }

  .books-title .c2 {
    position: absolute;
    bottom: 0;
    right: 0;
  }

  .detail_box div.leibie {
    position: relative;
  }

  .detail_box div.leibie .d1 span {
    display: inline-block;
    margin-right: 2px;
  }

  .detail_box div.leibie span {
    color: #4CADD3;
    font-size: 14px;
    padding-left: 10px;
  }

  .detail_box div.leibie:after {
    content: "";
    width: 0px;
    position: absolute;
    border: 1px solid #4CADD3;
    top: 7px;
    height: 25px;
  }

  .detail_box .public_date {
    margin-top: 15px;
    width: 100%;
    height: 30px;
    font-size: 14px;
    line-height: 17px;
    color: #2D2D2D;
    opacity: 1;
    /* display: flex; */
  }

  .detail_box .network {
    /* width: 248px; */
    height: 33px;
    font-size: 14px;
    line-height: 17px;
    color: #333333;
    opacity: 1;
  }

  .current_date {
    font-size: 14px;
    opacity: 1;
    color: #333;
  }

  .clearfix:after {
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }

  .down {
    height: 36px;
    text-align: center;
    position: absolute;
    bottom: 5%;
  }

  .down .down_wrap {
    height: 36px;
    text-align: left;
    /* margin-left: -68px; */
  }

  .down a.basic_msg {
    background-image: url(../common/style/img/qkwy.png);
    cursor: pointer;
  }

  .down a {
    width: 114px;
    height: 36px;
    font-size: 14px;
    line-height: 36px;
    text-align: center;
    color: rgba(51, 146, 168, 1);
    opacity: 1;
    padding-left: 20px;
    background: #eff7f7 url(../common/style/img/xiazai.png) no-repeat 10px 50%;
    background-size: 14px;
    display: inline-block;
    margin-right: 5px;
    border-radius: 4px;
  }

  .goTop {
    position: fixed;
    right: 100px;
    top: 85%;
  }

  .c_first,
  .c_secend {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .container .c_left {
    width: 48%;
    display: inline-block;
  }

  .span {
    color: #5E5E5E;
    font-size: 14px;
  }

  .container .c_left div {
    margin-top: 17px;
    color: #2D2D2D;
  }

  .container .c_right {
    width: 48%;
    display: inline-block;
  }

  .container .c_right div.div1 {
    line-height: 50px;
    height: 50px;
    color: #2D2D2D;
  }

  .container .c_right .div2 {
    line-height: 50px;
    height: 50px;
    position: relative;
    color: #2D2D2D;
  }

  .select_wrap {
    width: 100px;
    height: 30px;
    line-height: 30px;
    border: 1px solid #4CADD3;
    border-radius: 5px;
    text-align: center;
    overflow: hidden;
    display: inline-block;
    position: absolute;
    top: 13%;
  }

  .select_wrap select {
    border: 0px;
    width: 100%;
    height: 100%;
    text-align: center;
    text-align-last: center;
    outline: none;
    appearance: none;
    -webkit-appearance: none;
  }

  .price {
    margin: 10px auto;
  }

  .price span {
    color: #4CADD3;
  }

  .container .c_right div.div1 {
    color: #2D2D2D;
  }

  .copy2 {
    width: 80px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border: 1px solid #4CADD3;
    color: #4CADD3;
    border-radius: 5px;
    background: url(../common/style/img/copy.png) no-repeat;
    background-position: left 8px top 8px;
    padding-left: 16px;
    cursor: pointer;
    margin: 0px;
  }

  .c_bottom {
    margin-top: 46px;
  }

  .copy1 {
    margin-top: 10px;
    margin-bottom: 30px;
  }

  .down .link-ico {
    width: 114px;
    height: 36px;
    font-size: 14px;
    line-height: 36px;
    text-align: center;
    color: rgba(51, 146, 168, 1);
    opacity: 1;
    padding-left: 20px;
    background: #eff7f7 url(../common/style/img/xiazai.png) no-repeat 10px 50%;
    background-size: 14px;
    display: inline-block;
    margin-right: 5px;
    border-radius: 4px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Qikan.vue